import React from 'react';

export const pages = [
  {
    index: 0,
    fields: [
      'Select language',
      'Seleccione el idioma',
      'Simita akllay',
      'ENGLISH',
      'ESPAÑOL',
      'QUECHUA',
    ],
  },
  {
    index: 1,
    en: {
      title: '',
      fields: [
        'Welcome to AguaRiego',
        'This tool provides crop water use data and irrigation water needs data for typical crops in the Department of Arequipa, Peru including the Majes Irrigation, the City of Arequipa, and the Colca Valley.',
        'Continue',
        'In no event shall the creators, custodians, or distributors of this information be liable for any damages arising out of its use (or the inability to use it).',
      ],
    },
    es: {
      title: '',
      fields: [
        'Bienvenido a AguaRiego',
        'Esta herramienta proporciona datos de uso de agua de cultivo y datos de necesidades de agua de riego para cultivos típicos en la Región de Arequipa, Perú, incluyendo la Irrigación Majes, la Ciudad de Arequipa y el Valle del Colca.',
        'Continuar',
        'En ningún caso los creadores, custodios o distribuidores de esta información serán responsables de los daños que surjan de su uso (o la imposibilidad de usarla).',
      ],
    },
    qu: {
      title: '',
      fields: ['TRANSLATE', 'TRANSLATE', 'TRANSLATE', 'TRANSLATE'],
    },
  },
  {
    index: 2,
    en: {
      title: 'Select a weather station',
      fields: ['Selected station', 'Which units?'],
    },
    es: {
      title: 'Seleccione una estación meteorológica',
      fields: ['Seleccione la estación', '¿Qué unidades?'],
    },
    qu: {
      title: 'TRANSLATE',
      fields: ['Estacionta akllay', 'Akllay'],
    },
  },
  {
    index: 3,
    en: {
      title: 'Select crop(s):',
      fields: {
        majes: [
          { key: 'alfalfa', name: 'Alfalfa' },
          {
            key: 'artichoke 1st round',
            name: 'Artichoke (Feb.-Apr. planting)',
          },
          { key: 'artichoke 2nd round', name: 'Artichoke (Aug. planting)' },
          { key: 'corn 1st round', name: 'Corn (Aug.-Sept. planting)' },
          { key: 'corn 2nd round', name: 'Corn (Dec.-Jan. planting)' },
          { key: 'garlic', name: 'Garlic' },
          { key: 'potato 1st round', name: 'Potato (Feb.-Mar. planting)' },
          { key: 'potato 2nd round', name: 'Potato (Aug.-Sept. planting)' },
          { key: 'pumpkin 1st round', name: 'Pumpkin (Feb.-Mar. planting)' },
          { key: 'pumpkin 2nd round', name: 'Pumpkin (Aug.-Sept. planting)' },
          {
            key: 'red onion 1st round',
            name: 'Red onion (Mar.-Apr. planting)',
          },
          {
            key: 'red onion 2nd round',
            name: 'Red onion (Aug.-Sept. planting)',
          },
          { key: 'tomato', name: 'Tomato' },
          { key: 'quinoa', name: 'Quinoa' },
        ],
        arqpcty: [
          { key: 'alfalfa', name: 'Alfalfa' },
          { key: 'broccoli', name: 'Broccoli' },
          { key: 'corn', name: 'Corn' },
          { key: 'garlic', name: 'Garlic' },
          { key: 'green beans', name: 'Green beans' },
          { key: 'lettuce', name: 'Lettuce' },
          { key: 'onion', name: 'Onion' },
          { key: 'peas', name: 'Peas' },
          { key: 'quinoa', name: 'Quinoa' },
        ],
        colca: [
          { key: 'alfalfa', name: 'Alalfa' },
          { key: 'barley', name: 'Barley' },
          { key: 'broad beans', name: 'Broad beans' },
          { key: 'corn', name: 'Corn' },
          { key: 'peas', name: 'Peas' },
          { key: 'potato', name: 'Potato' },
          { key: 'quinoa', name: 'Quinoa' },
        ],
        labels: ['Crop', 'Select'],
      },
    },
    es: {
      title: 'Elige cultivos:',
      fields: {
        majes: [
          { key: 'alfalfa', name: 'Alfalfa' },
          {
            key: 'artichoke 1st round',
            name: 'Alcachofa (siembra en feb-abr)',
          },
          {
            key: 'artichoke 2nd round',
            name: 'Alcachofa (siembra en ago)',
          },
          { key: 'corn 1st round', name: 'Maiz (siembra en ago-sep)' },
          { key: 'corn 2nd round', name: 'Maiz (siembra en dic-ene)' },
          { key: 'garlic', name: 'Ajo' },
          { key: 'potato 1st round', name: 'Papa (siembra en feb-mar)' },
          { key: 'potato 2nd round', name: 'Papa (siembra en ago-sep)' },
          { key: 'pumpkin 1st round', name: 'Calabaza (siembra en feb-mar)' },
          { key: 'pumpkin 2nd round', name: 'Calabaza (siembra en ago-sep)' },
          {
            key: 'red onion 1st round',
            name: 'Cebolla roja (siembra en mar-abr)',
          },
          {
            key: 'red onion 2nd round',
            name: 'Cebolla roja (siembra en ago-sep)',
          },
          { key: 'tomato', name: 'Tomate' },
          { key: 'quinoa', name: 'Quinua' },
        ],
        arqpcty: [
          { key: 'alfalfa', name: 'Alfalfa' },
          { key: 'broccoli', name: 'Brócoli' },
          { key: 'corn', name: 'Maiz' },
          { key: 'garlic', name: 'Ajo' },
          { key: 'green beans', name: 'Vainas verdes' },
          { key: 'lettuce', name: 'Lechuga' },
          { key: 'onion', name: 'Cebolla' },
          { key: 'peas', name: 'Arveja' },
          { key: 'quinoa', name: 'Quinua' },
        ],
        colca: [
          { key: 'alfalfa', name: 'Alfalfa' },
          { key: 'barley', name: 'Cebada' },
          { key: 'broad beans', name: 'Habas' },
          { key: 'corn', name: 'Maiz' },
          { key: 'peas', name: 'Arveja' },
          { key: 'potato', name: 'Papa' },
          { key: 'quinoa', name: 'Quinua' },
        ],
        labels: ['Cultivo', 'Eligir'],
      },
    },
    qu: {
      title: 'TRANSLATE',
      fields: {
        majes: [
          { key: 'alfalfa', name: 'Alfalfa' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
        ],
        arqpcty: [
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
          { key: 'TRANSLATE', name: 'TRANSLATE' },
        ],
        colca: [
          { key: 'alfalfa', name: 'Alfalfa' },
          { key: 'cebada', name: 'Cebada' },
          { key: 'habas', name: 'Habas' },
          { key: 'sara', name: 'Sara' },
          { key: 'alverjas', name: 'Alverjas' },
          { key: 'papa', name: 'Papa' },
          { key: 'kinuwa', name: 'Kinuwa' },
        ],
        labels: ['TRANSLATE', 'TRANSLATE'],
      },
    },
  },
  {
    index: 4,
    en: {
      title: {
        ha: 'Crop water use (m³/ha)',
        topos: 'Crop water use (topos/ha)',
      },
      fields: {
        ha: [
          'Values in the table show total water needed by plants and do not account for irrigation water losses.',
          'Actual monthly water needs could be higher or lower than average values depending on growth stage',
          'Key:',
          'Growing - Growing season water needs (m³/ha)',
          'Avg. Monthly - Monthly water needs (m³/month/ha)',
          'Mo. grown - Months grown',
          'Planting - Assumed planting time',
          'Crop',
          'Growing',
          'Avg. Monthly',
          'Mo. grown',
          'Planting',
        ],
        topos: [
          'Values in the table show total water needed by plants and do not account for irrigation water losses.',
          'Actual monthly water needs could be higher or lower than average values depending on growth stage',
          'Key:',
          'Growing - Growing season water needs (m³/topos)',
          'Avg. Monthly - Monthly water needs (m³/month/topos)',
          'Mo. grown - Months grown',
          'Planting - Assumed planting time',
          'Crop',
          'Growing',
          'Avg. Monthly',
          'Mo. grown',
          'Planting',
        ],
      },
    },
    es: {
      title: {
        ha: 'Uso de agua de cultivo (m³/ha)',
        topos: 'Uso de agua de cultivo (m³/topos)',
      },
      fields: {
        ha: [
          'Los valores de la tabla muestran el agua total que necesitan los cultivos y no tienen en cuenta las pérdidas de agua de riego.',
          'Las necesidades de agua mensuales reales podrían ser mayores o menores que los valores promedio según la etapa de crecimiento.',
          'Leyenda:',
          'Época - Necesidad de agua durante la época de crecimiento (m³/ha)',
          'Promedio mensual - Necesidad de agua mensual (m³/ha)',
          'Mes. Cult. - Meses cultivado',
          'Siembra - Momento de siembra supuesto',
          'Cultivo',
          'Época',
          'Promedio mensual',
          'Mes. Cult.',
          'Siembra',
        ],
        topos: [
          'Los valores de la tabla muestran el agua total que necesitan los cultivos y no tienen en cuenta las pérdidas de agua de riego.',
          'Las necesidades de agua mensuales reales podrían ser mayores o menores que los valores promedio según la etapa de crecimiento.',
          'Leyenda:',
          'Época - Necesidad de agua durante la época de crecimiento (m³/topos)',
          'Promedio mensual - Necesidad de agua mensual (m³/topos)',
          'Mes. Cult. - Meses cultivado',
          'Siembra - Momento de siembra supuesto',
          'Cultivo',
          'Época',
          'Promedio mensual',
          'Mes. Cult.',
          'Siembra',
        ],
      },
    },
    qu: {
      title: '',
      fields: {
        ha: [
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
        ],
        topos: [
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
        ],
      },
    },
  },
  {
    index: 5,
    en: {
      title: {
        ha: 'Irrigation water needs (m³/month/ha)',
        topos: 'Irrigation water needs (m³/month/topos)',
      },
      fields: {
        ha: [
          'Values in the table show irrigation water needs, which account for efficiency differences among irrigation methods.',
          'Key:',
          'Surface - Surface irrigation water needs (m³/month/ha)',
          'Sprinkler - Sprinkler irrigation water needs (m³/month/ha)',
          'Drip - Drip irrigation water needs (m³/month/ha)',
          'Crop',
          'Surface',
          'Sprinkler',
          'Drip',
        ],
        topos: [
          'Values in the table show irrigation water needs, which account for efficiency differences among irrigation methods.',
          'Key:',
          'Surface - Surface irrigation water needs (m³/month/topos)',
          'Sprinkler - Sprinkler irrigation water needs (m³/month/topos)',
          'Drip - Drip irrigation water needs (m³/month/topos)',
          'Crop',
          'Surface',
          'Sprinkler',
          'Drip',
        ],
      },
    },
    es: {
      title: {
        ha: 'Necesidades de agua de riego (m³/mes/ha)',
        topos: 'Necesidades de agua de riego (m³/mes/topos)',
      },
      fields: {
        ha: [
          'Los valores de la tabla muestran las necesidades de agua de riego, que explican las diferencias de eficiencia entre los métodos de riego.',
          'Leyenda:',
          'Gravedad - Necesidad de riego por gravedad (m³/mes/ha)',
          'Aspersión - Necesidad de riego por aspersión (m³/mes/ha)',
          'Goteo - Necesidad de riego por goteo (m³/mes/ha)',
          'Cultivo',
          'Gravedad',
          'Aspersión',
          'Goteo',
        ],
        topos: [
          'Los valores de la tabla muestran las necesidades de agua de riego, que explican las diferencias de eficiencia entre los métodos de riego.',
          'Leyenda:',
          'Gravedad - Necesidad de riego por gravedad (m³/mes/topos)',
          'Aspersión - Necesidad de riego por aspersión (m³/mes/topos)',
          'Goteo - Necesidad de riego por goteo (m³/mes/topos)',
          'Cultivo',
          'Gravedad',
          'Aspersión',
          'Goteo',
        ],
      },
    },
    qu: {
      title: '',
      fields: {
        ha: [
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
        ],
        topos: [
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
          'TRANSLATE',
        ],
      },
    },
  },
  {
    index: 5,
    en: {
      title: 'About AguaRiego APP',
      fields: [
        'AguaRiego APP is a free mobile APP that provides crop water use data and irrigation water needs data for typical crops in the Department of Arequipa, Peru including the Majes Irrigation, the City of Arequipa, and the Colca Valley.',
        'Funding to support the research of the Nexus Institute of Arequipa for Food, Energy, Water and the Environment was provided by the National University of San Agustín.',
      ],
    },
    es: {
      title: 'Acerca de la APP AguaRiego',
      fields: [
        'AguaRiego APP es una aplicación móvil gratuita que proporciona datos de uso de agua de cultivo y datos de necesidades de agua de riego para cultivos típicos en el Departamento de Arequipa, Perú, incluyendo el Riego Majes, la Ciudad de Arequipa y el Valle del Colca.',
        'El financiamiento para apoyar la investigación del Instituto Nexus de Arequipa para Alimentos, Energía, Agua y Medio Ambiente fue proporcionado por la Universidad Nacional de San Agustín.',
      ],
    },
    qu: {
      title: 'TRANSLATE',
      fields: ['TRANSLATE', 'TRANSLATE'],
    },
  },
];

export const PageContext = React.createContext(pages[0]);
